t = require('app/scripts/views/internal/teacup-with-helpers')('search_suggetion')

module.exports = ->
  t.a '.search-suggestion.js-select-suggestion', { href: '#', 'data-suggestionphrase': t.mustacheVar('phrase') }, ->
    t.span '.search-suggestion-string', ->
      t.text t.mustacheVar('phrase')
    t.span '.search-suggestion-desc', ->
      t.text t.mustacheVar('description')
